import React, { useEffect} from "react"
import SMSTemplatesEditForm from "./editSMSTemplateForm"
import SideBar from "../../common/layout/sidebar.component.jsx"
import {RouteComponentProps} from "react-router"
import IntlProps from "../../state/helpers/IntlProps"

type PathParamsType = {
    templateKey: string,
}

type PropsType = RouteComponentProps<PathParamsType> & IntlProps & {
    templateKey: string,
}

const SMSTemplateNew = (props: PropsType) => {

    useEffect(() => {
        SideBar.activateMenu("sales-tools")
    },[])

    return (
        <div>
            <SMSTemplatesEditForm templateKey={props.match.params.templateKey} isNew={true}/>
        </div>
    )
}

export default SMSTemplateNew


// WEBPACK FOOTER //
// ./src/settings/sms/newSMSTemplate.tsx